export const REQUEST_SITES = 'REQUEST_SITES';
export const REQUEST_SITES_LOADING = 'REQUEST_SITES_LOADING';
export const REQUEST_SITES_SUCCESS = 'REQUEST_SITES_SUCCESS'
export const REQUEST_SITES_FAILED = 'REQUEST_SITES_FAILED'

export const SITE_MAIN_LOGO = 'SITE_MAIN_LOGO'
export const SITE_SUB_LOGO = 'SITE_SUB_LOGO'
export const SITE_BOUNDARY_FILE = 'SITE_BOUNDARY_FILE'